import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=bc7b13e0&scoped=true&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"
import style0 from "./Email.vue?vue&type=style&index=0&id=bc7b13e0&prod&lang=scss&scoped=true&"
import style1 from "./Email.vue?vue&type=style&index=1&id=bc7b13e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7b13e0",
  null
  
)

export default component.exports